import React from 'react'
import MainContentLayout from "../../../Layouts/Layout";
import {Head, useForm, usePage} from '@inertiajs/inertia-react'
import {Inertia} from "@inertiajs/inertia";

export default function CreateToken({userId, userName}) {
    const {errors} = usePage().props
    const {data, setData} = useForm({
        user_id: userId,
        token_name: userName,
        _token: usePage().props._token,
    });
    const [load, setLoad] = React.useState(false);

    function handleSubmit(e) {
        e.preventDefault();
console.log(data)
        Inertia.post('/helpers/mail-app-users/token/store', data, {
            onStart: () => {
                setLoad(true);
            },
            onFinish: () => {
                setLoad(false);
            },
        })
    }

    function handleBack(e) {
        e.preventDefault();

        Inertia.get('/helpers/mail-app-users');
    }

    return (
        <main>

            <Head title={"Create token"}/>

            <h1 className={"text-2xl"}>Create MailApp user token</h1>

            <form onSubmit={handleSubmit} className={"max-w-md mx-auto mt-8"}>
                <div className={"mb-6"}>
                    <label className={"block mb-2 uppercase font-bold text-xs text-gray-700"}>
                        Token name
                    </label>
                    <input className={"shadow appearance-none border rounded w-full py-2 px-3 text-gray-700" +
                        " leading-tight focus:outline-none focus:shadow-outline border border-solid border-gray-300" +
                        " p-2 w-full"} type={"text"} name={"token_name"} defaultValue={userName}
                           onChange={(e) =>
                               setData("token_name", e.target.value)
                           }
                    />
                    {errors.user_id && <div className={"text-red-700"}>{errors.user_id}</div>}
                    {errors.token_name && <div className={"text-red-700"}>{errors.token_name}</div>}
                </div>

                <div className={"flex mb-6 float-right space-x-2"}>
                    <button onClick={handleBack}
                            className={"inline-block px-6 py-2.5 bg-gray-200 text-gray-700 font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-gray-300 hover:shadow-lg focus:bg-gray-300 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-gray-400 active:shadow-lg transition duration-150 ease-in-out"}>
                        Back
                    </button>
                    <button type={"submit"}
                            className={"inline-block px-6 py-2.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"}
                            disabled={load}>
                        Submit
                    </button>
                </div>
            </form>
        </main>
    )
}

CreateToken.layout = page => (
    <MainContentLayout children={page}/>
)
